import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeTaxService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeTaxCreateDto,
  ContractTypeTaxDto,
  ContractTypeTaxExcelDownloadDto,
  ContractTypeTaxUpdateDto,
} from 'orchestrator';
import { CONTRACTTYPETAX_CONFIG, CONTRACTTYPETAX_FIELDS } from './contract-type-tax.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-tax',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeTaxService, ConfirmationService],
  templateUrl: './contract-type-tax.html',
  styleUrl: './contract-type-tax.scss',
})
export class ContractTypeTax extends BaseHierarchicalCrudComponent<
  ContractTypeTaxDto,
  ContractTypeTaxCreateDto,
  ContractTypeTaxUpdateDto,
  ContractTypeTaxExcelDownloadDto
> {
  service = inject(ContractTypeTaxService);
  config = CONTRACTTYPETAX_CONFIG;
  fields = CONTRACTTYPETAX_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeTaxDto): ContractTypeTaxUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeTax';
  }
}
